import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import MobileBanner from "../components/MobileBanner";
import Services from "../components/Services";
import Gallery from "../components/Gallery";
import WhyUs from "../components/WhyUs";
import Testimonials from "../components/Testimonials";
import BookingForm from "../components/BookingForm";
import Footer from "../components/Footer";
import FloatingContact from "../components/FloatingContact";

const Home = () => {
  return (
    <div className="bg-[#0A0A0A] text-white" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <MobileBanner />
        <Services />
        <Gallery />
        <WhyUs />
        <Testimonials />
        <BookingForm />
      </main>
      <Footer />
      <FloatingContact />
    </div>
  );
};

export default Home;
